import { useMemo } from "react";
import { Collapse } from "@mui/material";

// import { useQuery } from "react-query";
import { Text } from "$components";
import JTable from "$components/JTable/JTable";

import { Parcel } from "$types";

import { usePackageTypesQuery } from "$hooks/usePackageTypesQuery";
// import { ParcelService } from "$services";

type Props = {
  parcel: Parcel;
  showDetailsTable: boolean;
};

function ParcelTable({ parcel, showDetailsTable }: Props) {
  const { data: packageTypes = [] } = usePackageTypesQuery();

  const columns = useMemo(
    () => [
      {
        Header: "Type",
        maxWidth: 160,
        minWidth: 160,
        Cell: ({
          row: {
            original: { typeId },
          },
        }: any) => {
          const packageType = packageTypes?.find((p) => typeId === p.id);
          return (
            <Text
              type="important"
              style={{
                whiteSpace: "nowrap",
                display: "inline-block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                minWidth: "100%",
              }}
            >
              {packageType?.label}
            </Text>
          );
        },
      },
      {
        Header: "Longueur (cm)",
        minWidth: 80,
        maxWidth: 80,
        Cell: ({
          row: {
            original: { length },
          },
        }: any) => <Text>{length}</Text>,
      },
      {
        Header: "Largeur (cm)",
        minWidth: 80,
        maxWidth: 80,
        Cell: ({
          row: {
            original: { width },
          },
        }: any) => <Text>{width}</Text>,
      },
      {
        Header: "Hauteur (cm)",
        minWidth: 80,
        maxWidth: 80,
        Cell: ({
          row: {
            original: { height },
          },
        }: any) => <Text>{height}</Text>,
      },
      {
        Header: "Poids (kg)",
        minWidth: 80,
        maxWidth: 80,
        Cell: ({
          row: {
            original: { weight },
          },
        }: any) => <Text>{weight}</Text>,
      },
      {
        Header: "Quantité",
        minWidth: 80,
        maxWidth: 80,
        Cell: ({
          row: {
            original: { quantity },
          },
        }: any) => <Text>{quantity}</Text>,
      },
      {
        Header: "Poids total (kg)",
        minWidth: 80,
        maxWidth: 80,
        Cell: ({
          row: {
            original: { totalWeight },
          },
        }: any) => <Text>{totalWeight}</Text>,
      },
      {
        Header: "Actions",
        minWidth: 0,
        maxWidth: 0,
        Cell: () => null,
      },
    ],
    [packageTypes]
  );

  const totalColumns = useMemo(
    () => [
      {
        Header: "Total",
        maxWidth: 160,
        minWidth: 160,
        Cell: () => null,
      },
      {
        Header: "Mètre plancher linéaire",
        minWidth: 180,
        maxWidth: 180,
        Cell: ({
          row: {
            original: { loadingMeters },
          },
        }: any) => <Text>{loadingMeters}</Text>,
      },
      {
        Header: "Hauteur (cm)",
        minWidth: 180,
        maxWidth: 180,
        Cell: ({
          row: {
            original: { height },
          },
        }: any) => <Text>{height}</Text>,
      },
      {
        Header: "Quantité",
        minWidth: 90,
        maxWidth: 90,
        Cell: ({
          row: {
            original: { quantity },
          },
        }: any) => <Text>{quantity}</Text>,
      },
      {
        Header: "Poids total (kg)",
        minWidth: 80,
        maxWidth: 80,
        Cell: ({
          row: {
            original: { weight },
          },
        }: any) => <Text>{weight}</Text>,
      },
      {
        Header: "Actions",
        minWidth: 0,
        maxWidth: 0,
        Cell: () => null,
      },
    ],
    []
  );

  if (!parcel) {
    return <div>Pas de données de colisage disponibles</div>;
  }

  return (
    <>
      <Collapse in={showDetailsTable} timeout="auto" unmountOnExit>
        <JTable
          data={parcel.packages ?? []}
          columns={columns}
          pageCount={1}
          setFilter={() => {}}
          setPageIndex={() => {}}
          pageIndex={0}
          hideFilters
          hideCheckboxes
          rowProps={() => ({
            style: { cursor: "default" },
          })}
        />
      </Collapse>
      <JTable
        columns={totalColumns}
        data={[parcel]}
        hideFilters
        hideCheckboxes
        pageIndex={0}
        pageCount={1}
        setFilter={() => {}}
        setPageIndex={() => {}}
        rowProps={() => ({
          style: { cursor: "default" },
        })}
      />
    </>
  );
}

export default ParcelTable;
